// @flow
export const filterId: 'balanceType' = 'balanceType';
